interface PropsRedirect {
  code: string
  url: string
}

const REDIRECT = {
  PROCESSO_ANDAMENTO: {
    code: 'PROCESSO_ANDAMENTO',
    url: '/andamento',
  },
  SIMULACAO_SEM_CONSULTA: {
    code: 'SIMULACAO_SEM_CONSULTA',
    url: '/revisao',
  },
  SIMULACAO_AUTORIZADA: {
    code: 'SIMULACAO_AUTORIZADA',
    url: '/simulacao/dadoscontato',
  },
  ERRO_MENOR_IDADE: {
    code: 'MENOR_IDADE',
    url: '/erro',
  },
  ERRO_FORA_PERIODO_CONTRATACAO: {
    code: 'FORA_PERIODO_CONTRATACAO',
    url: '/erro',
  },
  LIMITE_ANTECIPACAO_EXCEDIDO: {
    code: 'LIMITE_ANTECIPACAO_EXCEDIDO',
    url: '/erro',
  },
  SEGUIR_SIMULACAO_APP: {
    code: 'SEGUIR_SIMULACAO_APP',
    url: '/conta/entrar',
  },
  NAO_AUTORIZADO: {
    code: 'NAO_AUTORIZADO',
    url: '/erro',
  },
  SALDO_INSUFICIENTE: {
    code: 'SALDO_INSUFICIENTE',
    url: '/erro',
  },
  NADA_POR_AQUI: {
    code: 'NADA_POR_AQUI',
    url: '/erro',
  },
  PERIODO_INDISPONIVEL: {
    code: 'PERIODO_INDISPONIVEL',
    url: '/erro',
  },

  ERRO: {
    code: 'ERRO',
    url: '/erro',
  },
}

const getRedirect = (redirect: string): PropsRedirect => {
  switch (redirect) {
    case 'PROCESSO_ANDAMENTO':
      return REDIRECT.PROCESSO_ANDAMENTO

    case 'SIMULACAO_SEM_CONSULTA':
      return REDIRECT.SIMULACAO_SEM_CONSULTA

    case 'SIMULACAO_AUTORIZADA':
      return REDIRECT.SIMULACAO_AUTORIZADA

    case 'ERRO_MENOR_IDADE':
      return REDIRECT.ERRO_MENOR_IDADE

    case 'ERRO_FORA_PERIODO_CONTRATACAO':
      return REDIRECT.ERRO_FORA_PERIODO_CONTRATACAO

    case 'LIMITE_ANTECIPACAO_EXCEDIDO':
      return REDIRECT.LIMITE_ANTECIPACAO_EXCEDIDO

    case 'SEGUIR_SIMULACAO_APP':
      return REDIRECT.SEGUIR_SIMULACAO_APP

    case 'NAO_AUTORIZADO':
      return REDIRECT.NAO_AUTORIZADO

    case 'SALDO_INSUFICIENTE':
      return REDIRECT.SALDO_INSUFICIENTE

    case 'NADA_POR_AQUI':
      return REDIRECT.NADA_POR_AQUI

    case 'PERIODO_INDISPONIVEL':
      return REDIRECT.PERIODO_INDISPONIVEL

    default:
      return REDIRECT.ERRO
  }
}

export default getRedirect
